import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import LegalModals from "./LegalModals";

const KEY = "atento-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    const t = saved ? null : setTimeout(() => setVisible(true), 1200);
    const reopen = () => setVisible(true);
    window.addEventListener("atento:cookies-open", reopen);
    return () => {
      if (t) clearTimeout(t);
      window.removeEventListener("atento:cookies-open", reopen);
    };
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    // src/analytics.js escucha este evento y activa o desactiva GA4
    window.dispatchEvent(new Event("atento:consent-changed"));
    setVisible(false);
  };

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            data-testid="cookie-banner"
            role="dialog"
            aria-label="Aviso de cookies"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:left-6 sm:bottom-6 sm:max-w-md z-[90] bg-white border border-atento-blue/10 rounded-3xl shadow-[0_20px_60px_rgba(12,29,56,0.18)] p-6 sm:p-7"
          >
            <div className="flex items-start gap-4">
              <span className="shrink-0 w-10 h-10 rounded-full bg-sage-light flex items-center justify-center">
                <Cookie className="w-5 h-5 text-sage-dark" strokeWidth={1.8} />
              </span>
              <div>
                <p className="font-accent font-semibold text-atento-blue text-sm">
                  Tu privacidad nos importa
                </p>
                <p className="mt-1.5 text-xs sm:text-sm leading-relaxed text-charcoal/65">
                  Utilizamos cookies técnicas necesarias para que la web funcione y, solo si las
                  aceptas, cookies de análisis para mejorarla. Puedes cambiar tu decisión cuando
                  quieras desde «Preferencias de cookies» en el pie de página.{" "}
                  <button
                    onClick={() => setLegal("cookies")}
                    data-testid="cookie-policy-link"
                    className="font-semibold text-atento-blue underline decoration-sage underline-offset-2 hover:decoration-atento-blue cursor-pointer"
                  >
                    Política de cookies
                  </button>
                </p>
              </div>
            </div>
            <div className="mt-5 flex gap-3">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="flex-1 bg-atento-blue hover:bg-atento-dark text-white font-accent font-semibold text-sm px-5 py-3 rounded-full transition-colors cursor-pointer"
              >
                Aceptar
              </button>
              <button
                onClick={() => choose("rejected")}
                data-testid="cookie-reject-button"
                className="flex-1 bg-sage/10 hover:bg-sage/20 text-atento-blue border border-sage/30 font-accent font-semibold text-sm px-5 py-3 rounded-full transition-colors cursor-pointer"
              >
                Rechazar
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <LegalModals open={legal} onClose={() => setLegal(null)} />
    </>
  );
}
